import { useState } from "react"
import { useDispatch } from 'react-redux';

import FormInput from "../form-input/form-input.component";
import Button from "../button/button.component";

import {
    createAuthUserWithEmailAndPassword,
    createUserDocumentFromAuth
} from "../../utils/firebase/firebase.utils.js"

import { SignUpContainer } from './sign-up-form.style.jsx'
import { signUpStart } from '../../store/user/user.action';



const defaultFormFields = {
    displayName: '',
    email: '',
    password: '',
    confirmPassword: '',
}


const USER_REGEX = /^[a-zA-Z][a-zA-Z0-9-_]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

const SingUpForm = () => {
    const [formFields, setFormFields] = useState(defaultFormFields)
    const { displayName, email, password, confirmPassword } = formFields
    const dispatch = useDispatch();


    const resetFormField = () => {
        setFormFields(defaultFormFields)
    }

    const handeleSubmit = async (event) => {
        event.preventDefault();
        if (password !== confirmPassword) {
            alert('passwords do not match')
            return;
        }
        try {
            dispatch(signUpStart(email, password, displayName));
            resetFormField ();
        } catch (error) {
            if (error.code === 'auth/email-already-in-use') {
                alert('Cannot create user, email already in use');
            } else {
                console.log('user creation encountered an error', error);
            }
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target
        setFormFields({ ...formFields, [name]: value })

    }
    return (
        <SignUpContainer >
            <h2>Don't have an account?</h2>
            <span>Sign up with your email and password </span>
            <form onSubmit={handeleSubmit}>

                <FormInput
                    label=' Display Name'
                    type="text"
                    required
                    onChange={handleChange}
                    name="displayName"
                    value={displayName} />

                <FormInput
                    type="email"
                    label='Email'
                    required
                    onChange={handleChange}
                    name="email"
                    value={email} />

                <FormInput
                    label='Password'
                    type="password"
                    required onChange={handleChange}
                    name="password"
                    value={password} />

                <FormInput
                    label='Confirm Password'
                    type="password"
                    required
                    onChange={handleChange}
                    name="confirmPassword"
                    value={confirmPassword} />
                <Button type="submit">Sing up</Button>
            </form>
        </SignUpContainer>
    )
}

export default SingUpForm